import React from 'react'
import { FaInfoCircle, FaSitemap } from 'react-icons/fa'
import { MdSettings } from 'react-icons/md'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { getContractId, getLotId } from 'store/selection'
import { useStyles } from 'hooks'
import { RouterTabs } from 'components/atoms'

export const LotTabs = () => {
  const { t } = useTranslation()
  const contractId = useSelector(getContractId)
  const lotId = useSelector(getLotId)

  const styles = useStyles(() => ({
    display: 'flex',
    alignItems: 'center',
    svg: { marginRight: '0.6rem' },
  }))

  const links = React.useMemo(
    () => [
      {
        path: `/contrat/${contractId}/lot/${lotId}/informations`,
        label: (
          <span css={styles}>
            <FaInfoCircle />
            {t('tabs.infos')}
          </span>
        ),
      },
      {
        path: `/contrat/${contractId}/lot/${lotId}/perimetre`,
        label: (
          <span css={styles}>
            <FaSitemap />
            {t('tabs.scope')}
          </span>
        ),
      },
      {
        path: `/contrat/${contractId}/lot/${lotId}/options`,
        label: (
          <span css={styles}>
            <MdSettings />
            {t('tabs.options')}
          </span>
        ),
      },
    ],
    [contractId, lotId, styles, t],
  )
  return <RouterTabs links={links} />
}
